
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.705 7.164l.07.06c.222.223.242.57.06.815l-.06.07-3.333 3.333a.625.625 0 01-.814.06l-.07-.06L.225 8.109a.625.625 0 01.814-.945l.07.06L4 10.117l2.891-2.891a.625.625 0 01.814-.06zM4.372.498l.07.06 3.333 3.333a.625.625 0 01-.814.945l-.07-.06L4 1.883 1.109 4.775a.625.625 0 01-.814.06l-.07-.06a.625.625 0 01-.06-.814l.06-.07L3.558.558a.625.625 0 01.814-.06z","fill":"#808C9A","fill-rule":"evenodd"}})])
          )
        }
      }
    